import { type HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: 'default' | 'green' | 'yellow' | 'red' | 'blue' | 'purple' | 'orange' | 'indigo' | 'secondary';
}

const variantStyles: Record<string, React.CSSProperties> = {
  default:   { backgroundColor: '#EDE7DC', color: '#6A6158', border: '1px solid #D4CCBF' },
  secondary: { backgroundColor: 'transparent', color: '#A09890', border: '1px solid #D4CCBF' },
  green:     { backgroundColor: '#EBF3EE', color: '#3A7A58', border: '1px solid #C2DDD0' },
  yellow:    { backgroundColor: '#F5EDD8', color: '#B07C18', border: '1px solid #E0CEAA' },
  red:       { backgroundColor: '#F5E8E7', color: '#A83830', border: '1px solid #E0BEBA' },
  blue:      { backgroundColor: '#E5EFF8', color: '#2E6EA6', border: '1px solid #BDD5EB' },
  purple:    { backgroundColor: '#EEEAF5', color: '#6B4FA0', border: '1px solid #D4CDE8' },
  orange:    { backgroundColor: '#F5ECDF', color: '#B86030', border: '1px solid #E0CDBA' },
  indigo:    { backgroundColor: '#ECEAF5', color: '#4A4A9A', border: '1px solid #CCCDE0' },
};

export function Badge({ className, variant = 'default', style, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-sm px-1.5 py-0.5 text-2xs font-medium tracking-wide uppercase',
        className,
      )}
      style={{ ...variantStyles[variant], ...style }}
      {...props}
    />
  );
}
